export default {
  baseUrl: 'https://api.geekchicstore07.pro',
  apiBaseUrl: 'https://api.geekchicstore07.pro/api'
  // // apiBaseUrl: 'http://127.0.0.1:8000'
};
